export default __webpack_public_path__ + "static/media/id-card.4b44ca0f.svg";